import { render, staticRenderFns } from "./GroupOptions.vue?vue&type=template&id=491041a4"
import script from "./GroupOptions.vue?vue&type=script&lang=ts"
export * from "./GroupOptions.vue?vue&type=script&lang=ts"
import style0 from "./GroupOptions.vue?vue&type=style&index=0&id=491041a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports